<template>
    <div
        v-if="slots?.trigger != null"
        ref="floatingRef"
        @click="setShowCustomElement"
    >
        <slot name="trigger"/>
    </div>

    <Teleport to="#tooltips-container">
        <div
            ref="floating"
            class="z-[9999]"
            v-if="showFloatingElement"
            :style="{
                ...floatingStyles,
                visibility: middlewareData?.hide?.referenceHidden
                    ? 'hidden'
                    : 'visible',
            }"
        >
            <slot/>
        </div>
    </Teleport>
</template>

<script setup>
import { ref, toRefs, Teleport, useSlots, shallowRef } from "vue";
import { useFloating, flip, offset, autoUpdate, hide,  } from "@floating-ui/vue";

import { useMouse, onClickOutside } from "@vueuse/core";

const slots = useSlots()
const { x, y } = useMouse()

const props = defineProps({
    placement: {
        type: String,
        default: 'bottom-center'
    }
})
const { placement } = toRefs(props);

const floatingRef = ref(null)
const floating = ref(null);
const showFloatingElement = shallowRef(false)

const setShowCustomElement = () => {
    showFloatingElement.value = !showFloatingElement.value
}

const hideFloatingElement = () => {
    showFloatingElement.value = false
}

onClickOutside(floating, hideFloatingElement);

const { floatingStyles, middlewareData } = useFloating(floatingRef, floating, {
    placement: placement.value,
    middleware: [flip(), offset(4), hide()],
    whileElementsMounted(...args) {
        return  autoUpdate(...args, {animationFrame: true});
    },
});
</script>
